import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import {
  ProductEnrichmentApiService,
  ProductEnrichmentCandidate,
  ProductEnrichmentRun
} from '../../new-catalog/product-enrichment/product-enrichment.service';

@Component({
  selector: 'app-product-ai-enrichment-dialog',
  templateUrl: './product-ai-enrichment-dialog.component.html',
  styleUrls: ['./product-ai-enrichment-dialog.component.scss']
})
export class ProductAiEnrichmentDialogComponent implements OnInit, OnDestroy {
  run?: ProductEnrichmentRun;
  candidates: ProductEnrichmentCandidate[] = [];
  loading = true;
  applying = false;
  error = '';
  private timer?: ReturnType<typeof setTimeout>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { productId: number; productName: string },
    private readonly api: ProductEnrichmentApiService,
    private readonly dialogRef: MatDialogRef<ProductAiEnrichmentDialogComponent>
  ) {}

  async ngOnInit() {
    try {
      this.run = await firstValueFrom(
        this.api.start({ productId: this.data.productId, useWeb: true })
      );
      await this.refresh();
    } catch (error) {
      console.error(error);
      this.error = 'Не удалось запустить AI-наполнение товара.';
      this.loading = false;
    }
  }

  ngOnDestroy() {
    if (this.timer) clearTimeout(this.timer);
  }

  get finished() {
    return ['COMPLETED', 'COMPLETED_WITH_ERRORS', 'FAILED', 'CANCELLED'].includes(
      this.run?.status || ''
    );
  }

  get selectedCount() {
    return this.candidates.filter((item) => item.selected).length;
  }

  toggleAll(checked: boolean) {
    this.candidates.forEach((item) => (item.selected = checked));
  }

  async apply() {
    const ids = this.candidates.filter((item) => item.selected).map((item) => item.id);
    if (!ids.length || this.applying) return;
    this.applying = true;
    try {
      await firstValueFrom(this.api.approve(ids));
      const result = await firstValueFrom(this.api.publish(ids));
      const published = result.filter((item) => item.published).length;
      if (published !== ids.length) {
        this.error = `Применено ${published} из ${ids.length} изменений.`;
        this.applying = false;
        return;
      }
      this.dialogRef.close({ published });
    } catch (error) {
      console.error(error);
      this.error = 'Не удалось применить выбранные изменения.';
      this.applying = false;
    }
  }

  private async refresh() {
    if (!this.run) return;
    try {
      const runs = await firstValueFrom(this.api.getRuns());
      this.run = runs.find((item) => item.id === this.run?.id) || this.run;
      if (this.finished) {
        this.candidates = await firstValueFrom(this.api.getCandidates(this.run.id));
        this.candidates.forEach((item) => (item.selected = item.risk !== 'RED'));
        this.loading = false;
        if (!this.candidates.length && this.run.failedCount) {
          this.error = this.run.message || 'AI не смог подготовить предложения.';
        }
        return;
      }
      this.timer = setTimeout(() => void this.refresh(), 1500);
    } catch (error) {
      console.error(error);
      this.error = 'Не удалось получить результат AI-наполнения.';
      this.loading = false;
    }
  }
}
